import styles from './badge.module.scss';
import MaterialBadge from '@mui/material/Badge';

/* eslint-disable-next-line */
export interface BadgeProps {
  // anchorOrigin?: {
  //   horizontal: 'left' | 'right',
  //   vertical: 'bottom' | 'top'
  // },
  badgeContent?: any,
  children: any,
  // classes?: object,
  color?:
  'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  // component?: any,
  // components?: { Badge?: any, Root?: any },
  // componentsProps?: object,
  invisible?: boolean,
  // max?: number,
  overlap?: 'circular' | 'rectangular',
  // showZero?: boolean,
  sx?: any,
  variant?: 'dot' | 'standard'
}

export function Badge(props: BadgeProps) {
  return (
    <MaterialBadge
      color={props.color}
      badgeContent={props.badgeContent}
      overlap={props.overlap}
      sx={props.sx}
      variant={props.variant}
      invisible={props.invisible}>
      {props.children}
    </MaterialBadge>
  );
}

export default Badge;